
import React from 'react';
import './style.scss';
import close from '../../../../../../../assets/clear-button.svg';

type Props = {
  showTickets: boolean;
  title: string;
  subtitle: string;
  toggleChat: () => void;
  showCloseButton: boolean;
  titleAvatar?: string;
  toggleTickets: () => void;
  handleStartNewSession: () => void;
  handleEndChat?: () => void;
  /** The Tickets view has no data source any more; it stays hidden unless this is set. */
  showTicketsTab?: boolean;
}

const menuButtonStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #FFF',
  borderRadius: 16,
  padding: '5px 10px',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  color: '#FFF',
  fontWeight: 'lighter',
};

function Header({ showTickets, title, subtitle, toggleChat, showCloseButton, titleAvatar, toggleTickets, handleStartNewSession, handleEndChat, showTicketsTab = false }: Props) {
  return (
    <div className="rcw-header">
      {showCloseButton &&
        <button className="rcw-close-button" onClick={toggleChat}>
          <img src={close} className="rcw-close" alt="close" />
        </button>
      }
      <div className='rcw-header-menu'>
        {showTicketsTab ? (
          <button
            onClick={toggleTickets}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: '#FFF',
              fontWeight: 'lighter',
            }}
          >
            <span style={{ transform: `rotate(${showTickets ? 180 : 0}deg)`, display: 'inline-block', marginRight: '5px' }}>&#9664;</span>
            {showTickets ? 'Chat' : 'Tickets'}
          </button>
        ) : (
          <span></span>
        )}
        <div style={{ display: 'flex', gap: 8, marginRight: '10px' }}>
          <button onClick={handleStartNewSession} style={menuButtonStyle} aria-label="Start a new chat">
            <span>New chat 💭</span>
          </button>
          {handleEndChat && (
            <button onClick={handleEndChat} style={menuButtonStyle} aria-label="End this chat">
              <span>End chat</span>
            </button>
          )}
        </div>
      </div>
      <h4 className="rcw-title">
        {titleAvatar && <img src={titleAvatar} className="avatar" alt="profile" />}
        {title}
      </h4>
      <span>{subtitle}</span>
    </div>
  );
}

export default Header;
